import React from 'react';
import { Card } from 'react-bootstrap';
import './cardHouse.css'

function CardHouse(props) {
  return (
    <Card className='card-house'>
      <Card.Img variant="top" src={props.img} alt=''/>
      <Card.Body style={{ backgroundColor: '#e0e0e0', color: 'black' }}>
        <Card.Text className='text-class'>
          {props.text}
        </Card.Text>
      </Card.Body>
    </Card>
  );
}

export default CardHouse;